import Component from '../core/Component';

export default class RewardModal extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        $(document).on('rewardModal:open', event => this.open())
        $(document).on('rewardModal:close', event => this.close())
    }

    open() {
        this.$element.addClass('is-active')

        setTimeout(() => {
            this.$element.addClass('is-animated')
        }, 0)
    }

    close() {
        this.$element.removeClass('is-animated')

        setTimeout(() => {
            this.$element.removeClass('is-active')
        }, 500)
    }
}


// WEBPACK FOOTER //
// ./components/RewardModal.js